<template>
  <svg
    width="11"
    height="15"
    viewBox="0 0 11 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.29213 14.054C1.50789 8.2668 0.805664 7.67256 0.805664 5.54626C0.822383 4.15879 1.35653 2.83413 2.29239 1.85922C3.22825 0.88431 4.49048 0.337646 5.80566 0.337646C7.12084 0.337646 8.38307 0.88431 9.31894 1.85922C10.2548 2.83413 10.7889 4.15879 10.8057 5.54626C10.8057 7.67342 10.1034 8.2668 6.3192 14.0549C6.26154 14.1422 6.1847 14.2136 6.09524 14.2628C6.00578 14.3121 5.90635 14.3377 5.80545 14.3376C5.70455 14.3376 5.60517 14.3117 5.51578 14.2623C5.4264 14.2129 5.34966 14.1415 5.29213 14.054ZM5.80607 7.74503C6.21802 7.74486 6.62068 7.61584 6.96315 7.37426C7.30561 7.13269 7.5725 6.78941 7.73007 6.38783C7.88764 5.98625 7.92883 5.54439 7.84842 5.11811C7.76802 4.69184 7.56962 4.30029 7.27833 3.99295C6.98703 3.68562 6.61591 3.47631 6.21188 3.39147C5.80784 3.30664 5.38904 3.35009 5.00841 3.51634C4.62779 3.68259 4.30242 3.96417 4.07345 4.32549C3.84448 4.6868 3.72219 5.11163 3.72203 5.54626C3.72203 5.83497 3.77594 6.12085 3.88068 6.38757C3.98542 6.65429 4.13895 6.89662 4.33248 7.10073C4.52601 7.30483 4.75576 7.46671 5.0086 7.57712C5.26144 7.68752 5.53243 7.74429 5.80607 7.74418V7.74503Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconOwnFilial',
  }
</script>

<style scoped lang="less">

</style>
